import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionRequestQuery extends AbstractGraphqlRequest<
  SolutionModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOneSolution(
        $id: GqlEntityIdType!
        $payload: SolutionRequestPayloadInput
      ) {
        findOneSolution(id: $id, payload: $payload) {
          id
          category {
            id
            title
            description
          }
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          picture {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOneSolution;

    if (item) {
      return new SolutionModel(item);
    }

    return new ItemNotFound();
  }
}
